import z from 'zod';
import UserRole from "./roles";
import {phoneNumberSchema} from "../common/phoneNumberSchema";
import paginatedSchema from "../common/paginatedSchema";

const userRoleSchema = z.enum([UserRole.ADMIN, UserRole.USER, UserRole.COMMODORE, UserRole.ORGANIZER]);
const userAccountSchema = z.object({
    id: z.number(),
    username: z.string()
        .min(1, {message: "Uživatelské jméno nesmí být prázdné"}),
    email: z.string()
        .email("Neplatný email")
        .min(5, {message: "Email musí mít alespoň 5 znaků"})
        .max(100, {message: "Email může mít maximálně 100 znaků"}),
    firstName: z.string()
        .min(1, {message: "Jméno nesmí být prázdné"})
        .max(50, {message: "Jméno může mít maximálně 50 znaků"}),
    lastName: z.string()
        .min(1, {message: "Příjmení nesmí být prázdné"})
        .max(50, {message: "Příjmení může mít maximálně 50 znaků"}),
    roles: userRoleSchema.array(),
    phoneNumber: phoneNumberSchema
        .optional().or(z.literal("")),
    enabled: z.boolean(),
});

const paginatedUserAccountSchema = paginatedSchema(userAccountSchema);

type UserAccount = z.infer<typeof userAccountSchema>;
type PaginatedUserAccounts = z.infer<typeof paginatedUserAccountSchema>;

export {userAccountSchema, type UserAccount, paginatedUserAccountSchema, type PaginatedUserAccounts};